import React, { useContext } from 'react';
import LocaleContext from '../../constants/localization';

const PasswordExpiryRadio = ({
  passwordExpiryInMonths,
  setPasswordExpiryInMonths,
  passwordExpiryRadio,
  setPasswordExpiryRadio,
}) => {
  const LS = useContext(LocaleContext);

  return (
    <>
      <div className="password-expiry--radio">
        <input
          type="radio"
          value="yes"
          name="passwordexpiry"
          checked={passwordExpiryRadio}
          onChange={(e) => {
            setPasswordExpiryRadio(true);
          }}
        />
        <label htmlFor="yes">{LS.manageUsers.expiryYes}</label>
        <input
          type="number"
          value={passwordExpiryInMonths}
          style={{ width: 'auto' }}
          onChange={(e) => {
            setPasswordExpiryInMonths(+e.target.value);
            setPasswordExpiryRadio(true);
          }}
          required={passwordExpiryRadio}
        ></input>
      </div>
      <div className="password-expiry--radio">
        <input
          type="radio"
          value="no"
          name="passwordexpiry"
          checked={passwordExpiryRadio === false}
          onChange={(e) => {
            setPasswordExpiryRadio(false);
          }}
        />
        <label htmlFor="no">{LS.manageUsers.expiryNo}</label>
      </div>
    </>
  );
};

export default PasswordExpiryRadio;
